export const SSO_CALLBACK_PATH = '/login/sso-callback';
